module.exports = __webpack_public_path__ + "media/newstyle/images/facebook-share-pink-0578b823cc8e4fe227cf5b2689a89bd7.svg";